import React from 'react'
import { observer } from 'mobx-react-lite'
import TableCell from '@mui/material/TableCell'
import { Column } from '../CustomTable'
import { stylesRowOpenedNoBorder } from './shared-styles'
import { CustomTableLocalRow } from '../CustomTableLocalRow'
import useCustomTableRenderLog from '../hooks/useCustomTableRenderLog'
import useStore from 'reusable/mobx-store-utils'
import useClasses from 'theme/UseClasses'

interface CustomTableRowCellProps<RowData extends AnyObject, RowStore> {
   column: Column<RowData, RowStore>
   localRow: CustomTableLocalRow<RowData, RowStore>
   rowIndex: number
}

export const CustomTableRowCell = observer(function CustomTableRowCell
   <RowData extends AnyObject, RowStore>(props: CustomTableRowCellProps<RowData, RowStore>) {
   useCustomTableRenderLog('CustomTableRowCell')
   const classes = useClasses(stylesRowOpenedNoBorder)

   const localStore = useStore(
      sp => ({
         get cellStyle() {
            let style = {}
            if (sp.column && sp.column.cellStyle) {
               if (typeof sp.column.cellStyle === 'function') {
                  style = sp.column.cellStyle(sp.localRow.row, sp.localRow.rowStore)
               } else {
                  style = sp.column.cellStyle
               }
            }
            return style
         },
      }),
      props
   )

   if (props.column.hidden) {
      return null
   }

   let render = null
   if (props.column.rendererComponent) {
      const Component = props.column.rendererComponent
      render = <Component data={props.localRow.row} rowStore={props.localRow.rowStore} />
   } else if (props.column.render) {
      render = props.column.render(props.localRow.row, props.localRow.rowStore) || null
   } else if (props.column.field) {
      render = props.localRow.row[props.column.field] as any
   }

   return (
      <TableCell
         className={props.localRow.collapsibleOpen ? classes.cellOpened : classes.cellClosed}
         align={props.column.align}
         style={localStore.cellStyle}>
         {render}
      </TableCell>
   )
}
)
